import { render, staticRenderFns } from "./AbstractRoute.vue?vue&type=template&id=b58757a8&scoped=true&"
import script from "./AbstractRoute.vue?vue&type=script&lang=js&"
export * from "./AbstractRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58757a8",
  null
  
)

export default component.exports